import * as React from 'react';
const SvgDesign = (props) => (
  <svg viewBox="0 0 166 146" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g
      clipPath="url(#design_svg__a)"
      stroke="#000"
      strokeWidth={3.6}
      strokeLinecap="round"
      strokeLinejoin="round">
      <path d="M157.969 2.365H8.03c-3.132 0-5.672 2.547-5.672 5.689v129.892c0 3.142 2.54 5.689 5.672 5.689H157.97c3.133 0 5.673-2.547 5.673-5.689V8.054c0-3.142-2.54-5.69-5.673-5.69ZM2.358 27.567h161.284" />
      <path d="M140.945 39.797H21.242a4.42 4.42 0 0 0-4.413 4.426v11.46a4.42 4.42 0 0 0 4.413 4.425h119.703a4.42 4.42 0 0 0 4.413-4.426v-11.46a4.42 4.42 0 0 0-4.413-4.425ZM45.347 72.56h-25.23a3.292 3.292 0 0 0-3.288 3.298v25.304a3.292 3.292 0 0 0 3.288 3.297h25.23a3.292 3.292 0 0 0 3.288-3.297V75.858a3.292 3.292 0 0 0-3.288-3.297ZM67.64 104.459a2.91 2.91 0 0 1-2.91-2.918V75.487c0-1.615 1.3-2.926 2.91-2.926h25.978a2.918 2.918 0 0 1 2.917 2.925v13.46M112.616 93.216V75.858a3.292 3.292 0 0 1 3.287-3.297h25.23a3.292 3.292 0 0 1 3.288 3.297v25.304a3.292 3.292 0 0 1-3.288 3.297h-13.972M14.633 15.628h5.349M35.362 15.628h5.343M56.085 15.628h5.35" />
      <path d="m105.953 130.845 3.988 4 7.593-7.608-15.219-15.277 11.951-5.71L76.04 93.216l12.983 38.345 5.693-11.987" />
    </g>
    <defs>
      <clipPath id="design_svg__a">
        <path fill="#fff" d="M0 0h166v146H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgDesign;
